{
  "display": false,
  "group": "layer",
  "format": "geojson",
  "srid": "3857",
  "geom": "geom_3857",
  "qID": "id",
  "style": {
    "default": {
      "strokeWidth": "0",
      "fillColor": "#13336b",
      "fillOpacity": 0.4,
      "strokeColor": "#13336b",
      "icon": {
        "type": "dot",
        "fillColor": "#13336B"
      }
    },
    "highlight": {
      "scale": 1.3,
      "strokeWidth": 2,
      "strokeColor": "hotpink"
    }
  }
}
